// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"5f1c1bbd","270":"705aa66a","345":"56bb25dd","346":"9f30c0a6","453":"926f0775","555":"d061c19e","788":"6da11153","956":"ccac6162","969":"e1748c8b"}[chunkId] + ".chunk.js";
};